import React, { Suspense } from 'react'
import Header from 'src/components/Header/Header'
import Loading from 'src/components/Loading/Loading'

import Assets from './Assets/Assets'

import './Home.sass'

const Home = () => {

  return (
    <div id="home" className="page">
      <Header />
      <section id="page-content">
        <div className="container">
        <Suspense fallback={<Loading />}>
          <Assets />
        </Suspense>
        </div>
      </section>
    </div>
  )
}

export default Home
